import React, { useState, useEffect } from "react";

const JoinCommunityForm = () => {
  const [name, setName] = useState("");
  const [nickname, setNickname] = useState("");
  const [location, setLocation] = useState("");
  const [showOverlay, setShowOverlay] = useState(false);
  const [encodedMessage, setEncodedMessage] = useState("");
  const [showCopyNotif, setShowCopyNotif] = useState(false);

  const handleAutoJoin = () => {
    const message = `Halo kak saya ingin join komunitas, nama saya ${name}, nama panggilan atau cosplay saya ${nickname}, domisili ${location}`;
    setEncodedMessage(message);
    setShowOverlay(true);
  };

  const handleCopyMessage = () => {
    navigator.clipboard.writeText(encodedMessage);
    setShowCopyNotif(true);
    setTimeout(() => {
      setShowCopyNotif(false);
      window.location.href = "https://www.instagram.com/ihhwibu_community/";
    }, 1000);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOverlay(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [showOverlay]);

  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden w-full">
      <div className="container mx-auto flex flex-col md:flex-row ">
        {/* Image Section */}
        <div className="md:w-5/12 md:flex-shrink-0">
          <img
            src="/image/card/iwcard.webp"
            alt="IW Card"
            className="w-90 h-auto rounded"
          />
        </div>

        {/* Form Section */}
        <div className="flex-grow p-8 md:pl-0 md:pr-8 ml-3">
          <h2 className="text-2xl font-semibold mb-4 text-center">Join Our Community</h2>
          <p className="text-lg leading-relaxed mb-4">
            Kami senang Anda tertarik untuk bergabung dengan komunitas kami!
            Silakan isi formulir di bawah ini untuk bergabung.
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAutoJoin();
            }}
          >
            <div className="mb-4">
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700"
              >
                Nama
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-md focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="nickname"
                className="block text-sm font-medium text-gray-700"
              >
                Nickname
              </label>
              <input
                type="text"
                id="nickname"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-md focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="location"
                className="block text-sm font-medium text-gray-700"
              >
                Domisili
              </label>
              <input
                type="text"
                id="location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-md focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <button
              type="submit"
              className="bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline mx-auto block"
            >
              Bergabung
            </button>
          </form>
        </div>
      </div>

      {/* Overlay Section */}
      {showOverlay && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
          <div className="bg-white p-4 rounded-lg shadow-lg flex flex-col items-center">
            <p className="text-xl font-semibold mb-4">
              Terima kasih telah bergabung!
            </p>
            <p className="text-lg mb-4">
              Copy pesan di bawah ini untuk bergabung:
            </p>
            <p className="text-lg mb-4">
              Lalu DM Ke instagram @ihhwibu_community
            </p>
            <div className="mb-4 p-2 border border-gray-300 rounded-md">
              {encodedMessage}
            </div>
            <button
              onClick={handleCopyMessage}
              className="bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Copy Pesan
            </button>
          </div>
        </div>
      )}

      {/* Copy Notification Section */}
      {showCopyNotif && (
        <div className="fixed top-0 left-0 m-4 bg-green-500 text-white p-2 rounded shadow-lg">
          Message copied to clipboard!
        </div>
      )}
    </div>
  );
};

export default JoinCommunityForm;
